import script from "./homePage.vue?vue&type=script&setup=true&lang=js"
export * from "./homePage.vue?vue&type=script&setup=true&lang=js"

import "./homePage.vue?vue&type=style&index=0&id=196c7e49&lang=css"

const __exports__ = script;

export default __exports__